/* eslint-disable react/jsx-props-no-spreading */

// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './Dropzone.module.css';

/**
 * Dropzone component
 * @param {object} props
 * @param {string} props.id - Id of the dropzone
 * @param {string} props.label - Label of the dropzone
 * @param {boolean} props.disabled - Whether the dropzone is disabled
 * @param {{getRootProps: () => object, getInputProps: () => object, isDragActive: boolean, isDragAccept: boolean}} props.dropzoneProps - Dropzone props
 * @returns {JSX.Element} Dropzone component
 */
function Dropzone({
  id, label, disabled, dropzoneProps,
}) {
  return (
    <div
      {...dropzoneProps.getRootProps()}
      className={cn([
        styles.dropzone,
        ...(disabled ? [styles.disabled] : []),
        ...(dropzoneProps?.isDragActive && dropzoneProps?.isDragAccept ? [styles.active] : []),
      ])}
      data-testid={id}
    >
      <div className={styles.head}>
        <input {...dropzoneProps.getInputProps()} />
        <span className={styles.label}>
          {label}
        </span>
      </div>
      {/* <span className={styles['supported-label']}>
        {supportedFileLabel}
      </span> */}
    </div>
  );
}

export default Dropzone;
